import { j as o } from "./country-5727f554.js";
const e = (r) => {
  const { children: s, ...t } = r;
  return /* @__PURE__ */ o.jsx("a", { ...t, children: s });
};
export {
  e as L
};
//# sourceMappingURL=link-18c4cbfa.js.map
